// extracted by mini-css-extract-plugin
export default {"social":"Social_social__NkmQA","icon":"Social_icon__3TE-L","iconHeading":"Social_iconHeading__oloIl"};